import { DescriptedLabel } from 'iebt-zing-storybook'
import { buildValidations, handleValidation } from '../../behaviors/validation'
import { DateTime } from 'luxon'
import React, { useState, useEffect } from 'react'
import { IDatePicker } from '../../constants'
import DatePicker from 'react-datepicker'
import { ErrorLabel, FormItem } from '../../style'
import { useSelector, TReducers } from '../../../../../../../../store'

export function BuildDatePicker(item: IDatePicker, key: number | string): JSX.Element {
  const [date, setDate] = useState(item.value)
  const isRequired = item.isRequired ?? false
  const formStateValues = useSelector((state: TReducers) => state.hubChallengeBasicFormState)

  const validateDateComparison = (selectedDate: string | null, fieldId: string): string => {
    if (!selectedDate) return ''

    const selected = new Date(selectedDate)
    selected.setHours(0, 0, 0, 0)
    const today = new Date(new Date().toDateString())
    today.setHours(0, 0, 0, 0)
    
    if (selected < today) {
      return 'Não é possível criar programas com data anterior à atual'
    }

    const errorElement = document.getElementsByClassName(`errors-${fieldId}`)[0] as HTMLElement
    if (!errorElement) return ''

    const dateComparisons: Record<string, { compareWith: string, errorMessage: string, shouldBeBefore?: boolean, shouldBeAfter?: boolean }> = {
      launchDate: {
        compareWith: 'finalSelectionDate',
        errorMessage: 'A data de início das inscrições não pode ser maior que a data de encerramento das inscrições',
        shouldBeBefore: true
      },
      applicationStartDate: {
        compareWith: 'finalSelectionDate',
        errorMessage: 'A data de aplicação não pode ser maior que a data de encerramento das inscrições',
        shouldBeBefore: true
      },
      finalSelectionDate: {
        compareWith: 'launchDate',
        errorMessage: 'A data de encerramento das inscrições não pode ser menor que a data de início das inscrições',
        shouldBeBefore: false
      },
      evaluationStartDate: {
        compareWith: 'finalSelectionDate',
        errorMessage: 'A data de início das avaliações deve ser maior ou igual à data de encerramento das inscrições',
        shouldBeAfter: true
      },
      closingDate: {
        compareWith: 'evaluationStartDate',
        errorMessage: 'A data de encerramento das avaliações não pode ser menor que a data de início das avaliações',
        shouldBeBefore: false
      }
    }

    const comparison = dateComparisons[fieldId]
    if (!comparison) return ''

    const compareDateValue = formStateValues.config.step[comparison.compareWith as keyof typeof formStateValues.config.step] as string | null
    if (!compareDateValue) return ''

    const compareDate = new Date(compareDateValue)
    compareDate.setHours(0, 0, 0, 0)

    if (comparison.shouldBeBefore && selected > compareDate) {
      return comparison.errorMessage
    } else if (!comparison.shouldBeBefore && selected < compareDate) {
      return comparison.errorMessage
    } else if (comparison.shouldBeAfter && selected < compareDate) {
      return comparison.errorMessage
    }

    return ''
  }

  // Validar quando outras datas mudarem
  useEffect(() => {
    if (item.value) {
      const errorMessage = validateDateComparison(item.value, item.id)
      const errorElement = document.getElementsByClassName(`errors-${item.id}`)[0] as HTMLElement
      if (errorElement) {
        if (errorMessage) {
          errorElement.textContent = errorMessage
          const inputElement = document.getElementById(item.id) as HTMLElement
          if (inputElement) {
            inputElement.classList.add('is-invalid')
          }
        } else {
          errorElement.textContent = ''
          const inputElement = document.getElementById(item.id) as HTMLElement
          if (inputElement) {
            inputElement.classList.remove('is-invalid')
          }
        }
      }
    }
  }, [formStateValues.config.step.launchDate, formStateValues.config.step.applicationStartDate, formStateValues.config.step.finalSelectionDate, formStateValues.config.step.evaluationStartDate, formStateValues.config.step.closingDate, item.value, item.id])

  return (
    <FormItem key={key}>
      <DescriptedLabel description={item.description} boldText={isRequired} htmlFor={item.id}>
        <span>
          {item.label}
          {isRequired && <span style={{ color: 'red' }}> *</span>}
        </span>
      </DescriptedLabel>
      <DatePicker
        id={item.id}
        disabled={item.disabled}
        className={`form-control ${item.id} ${buildValidations(item.validations)}`}
        dateFormat='dd/MM/yyyy'
        maxDate={item.maxDate}
        minDate={item.minDate}
        selected={
          date != null
            ? new Date(`${String(date)}T00:00`)
            : null}
        onChange={(selectedDate) => {
          if (selectedDate != null) {
            const pickedDate = DateTime.fromJSDate(selectedDate)
            item.value = pickedDate.toISODate()
          } else {
            item.value = null
          }
          if (item.updateFieldState !== undefined) {
            item.updateFieldState(item)
          }
          setDate(item.value)
          
          const errorMessage = validateDateComparison(item.value, item.id)
          const errorElement = document.getElementsByClassName(`errors-${item.id}`)[0] as HTMLElement
          if (errorElement) {
            if (errorMessage) {
              errorElement.textContent = errorMessage
              const inputElement = document.getElementById(item.id) as HTMLElement
              if (inputElement) {
                inputElement.classList.add('is-invalid')
              }
            } else {
              errorElement.textContent = ''
              const inputElement = document.getElementById(item.id) as HTMLElement
              if (inputElement) {
                inputElement.classList.remove('is-invalid')
              }
            }
          }
        }}
      />
      <ErrorLabel className={`errors-${item.id}`}></ErrorLabel>
    </FormItem>
  )
}
